/* UK presentation layer. Generation, saved portraits and cart submissions use the existing theme engine. */
(() => {
  const start = () => {
    const root = document.querySelector('[data-uk-portrait]');
    if (!root || root.dataset.initialized) return;
    const composer = document.querySelector('.gemini-transformer');
    const legacy = composer?.closest('.product-single');
    const form = document.querySelector('form[id^="AddToCartForm--"]');
    const master = form?.querySelector('select[name="id"]');
    const nativeOrder = form?.querySelector('button[name="add"]');
    if (!composer || !legacy || !form || !master || !nativeOrder) return;
    let product;
    try { product = JSON.parse(root.querySelector('[data-uk-product]').textContent); } catch (_) { return; }
    root.dataset.initialized = 'true';
    const variants = product.variants;
    const $ = selector => root.querySelector(selector);
    const file = composer.querySelector('input[type="file"]');
    const generate = composer.querySelector('.gemini-transformer__button');
    const order = $('[data-uk-order]');
    const urlInput = () => form.querySelector('input[name="properties[Portrait URL]"]');
    const canvas = v => /^canvas/i.test(v.options[0]);
    const finishOf = v => canvas(v) ? 'canvas' : /black/i.test(v.options[1]) ? 'black' : /white/i.test(v.options[1]) ? 'white' : /natural|wood/i.test(v.options[1]) && !/no frame/i.test(v.options[1]) ? 'natural' : 'none';
    const sizeOf = v => canvas(v) && /30\s*[x×]\s*40\s*cm/i.test(v.options[0]) ? '30X40' : (v.options[0].match(/A[234]/i) || [v.options[0]])[0].toUpperCase();
    const names = {canvas:'Canvas',none:'Print only',black:'Black frame',white:'White frame',natural:'Natural wood'};
    const frameKeys = ['black','white','natural'];
    const familyOf = key => frameKeys.includes(key) ? 'framed' : key;
    const dimensions = {A4:'21 × 29.7 cm',A3:'29.7 × 42 cm',A2:'42 × 59.4 cm','30X40':'30 × 40 cm'};
    const sizeNames = {A4:'Small',A3:'Medium',A2:'Large','30X40':'Large'};
    const money = variant => variant?.money.replace(/<[^>]*>/g,'') || 'Unavailable';
    let selected = variants.find(v => String(v.id) === String(product.selectedId)) || variants.find(v => v.available);
    let finish = finishOf(selected), size = sizeOf(selected), demo = false, portrait = '', syncing = false;
    const preferredCanvas = variants.find(v => canvas(v) && v.available);
    if (!new URLSearchParams(location.search).has('variant') && preferredCanvas) {
      selected = preferredCanvas; finish = 'canvas'; size = sizeOf(selected);
    }
    let preferredFrame = frameKeys.includes(finish) ? finish : frameKeys.find(key => variants.some(v => finishOf(v) === key && v.available));
    $('[data-uk-composer-mount]').appendChild(composer);
    legacy.classList.add('uk-portrait-legacy');
    legacy.setAttribute('aria-hidden', 'true');
    root.hidden = false;
    const uploadLabel = composer.querySelector('.gemini-transformer__label--upload');
    if (uploadLabel && file) {
      [...uploadLabel.childNodes].filter(n => n.nodeType === 3).forEach(n => n.remove());
      const labelText = document.createElement('span');
      labelText.textContent = 'Create My Free Preview';
      const arrow = document.createElementNS('http://www.w3.org/2000/svg','svg');
      arrow.setAttribute('class','personalisation-upload-button__arrow');
      arrow.setAttribute('viewBox','0 0 24 24');
      arrow.setAttribute('aria-hidden','true');
      arrow.setAttribute('focusable','false');
      const arrowPath = document.createElementNS('http://www.w3.org/2000/svg','path');
      arrowPath.setAttribute('d','M4 12h15M13 5l7 7-7 7');
      arrow.appendChild(arrowPath);
      uploadLabel.prepend(labelText,arrow);
      file.setAttribute('aria-label', 'Create My Free Preview');
    }
    const styleNames = ['Floral','Painted','Impasto','Pencil','Watercolour'];
    let examples = [];
    try { examples = JSON.parse($('[data-uk-examples]')?.textContent || '[]'); } catch (_) {}
    let demoArtwork = examples[0]?.after || product.example;
    let exampleRequest = 0;
    const exampleCache = new Map();
    function loadExampleImage(src) {
      if (!exampleCache.has(src)) exampleCache.set(src, new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(src);
        img.onerror = () => { exampleCache.delete(src); reject(new Error('Example image could not be loaded')); };
        img.src = src;
      }));
      return exampleCache.get(src);
    }
    function selectExample(index) {
      const example = examples[index];
      if (!example || !$('[data-uk-before]')) return;
      const request = ++exampleRequest;
      const comparison = $('[data-uk-comparison]');
      comparison.setAttribute('aria-busy','true');
      const error = $('[data-uk-example-error]');
      if (error) error.hidden = true;
      const hasBefore = Boolean(example.before);
      // Apply each example together so rapid style clicks cannot mix different portraits.
      Promise.all([hasBefore ? loadExampleImage(example.before) : Promise.resolve(),loadExampleImage(example.after)]).then(() => {
        if (request !== exampleRequest) return;
        if (hasBefore) {
          $('[data-uk-before]').src = example.before;
          $('[data-uk-before]').alt = `Example pet photo before the ${example.name.toLowerCase()} portrait`;
        }
        $('.uk-portrait__before').hidden = !hasBefore;
        $('.pop-reassurance-example__arrow').hidden = !hasBefore;
        $('.uk-portrait__after figcaption').textContent = hasBefore ? 'Your portrait' : 'Style example';
        comparison.dataset.exampleOnly = String(!hasBefore);
        $('[data-uk-example]').src = example.after;
        $('[data-uk-example]').alt = `Example ${example.name.toLowerCase()} pet portrait on canvas`;
        comparison.setAttribute('aria-label', hasBefore ? `${example.name} photo-to-portrait example` : `${example.name} portrait example`);
        root.dataset.exampleStyle = example.name;
        demoArtwork = example.after;
      }).catch(() => {
        if (request !== exampleRequest) return;
        if (error) { error.textContent = 'Example unavailable — please try this style again.'; error.hidden = false; }
      }).finally(() => { if (request === exampleRequest) comparison.setAttribute('aria-busy','false'); });
    }
    const styleButtons = [...composer.querySelectorAll('.gemini-transformer__styles .gemini-style')];
    root.dataset.styleCount = String(styleButtons.length);
    styleButtons.forEach((button, index) => {
      button.setAttribute('aria-label', styleNames[index] || `Style ${index + 1}`);
      const example = examples[index];
      if (example && button.querySelector('img')) {
        button.querySelector('img').src = example.after;
        button.querySelector('img').alt = `${example.name} portrait style`;
      }
      button.addEventListener('click', () => {
        if (example) { selectExample(index); return; }
        const src = button.querySelector('img')?.getAttribute('src');
        if (src) $('[data-uk-example]').src = src;
      });
    });
    if (examples.length) {
      root.dataset.exampleStyle = examples[0].name;
      const initiallySelected = styleButtons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      if (initiallySelected > 0) selectExample(initiallySelected);
    }
    if (!examples.length) $('[data-uk-example]').addEventListener('error', function () {
      if (this.getAttribute('src') !== product.example) this.src = product.example;
    });
    function chooseVariant(nextFinish, nextSize) {
      const matches = variants.filter(v => finishOf(v) === nextFinish);
      return matches.find(v => sizeOf(v) === nextSize && v.available) || matches.find(v => v.available) || matches[0];
    }
    function syncNative() {
      if (!selected || syncing) return;
      syncing = true;
      selected.options.forEach((value, i) => {
        const select = form.querySelector(`select[data-index="option${i + 1}"]`);
        if (select) { select.value = value; select.dispatchEvent(new Event('change', {bubbles:true})); }
        else form.querySelectorAll(`[data-index="option${i + 1}"] input[type="radio"],input[data-index="option${i + 1}"]`).forEach(input => {
          input.checked = input.value === value;
          if (input.checked) input.dispatchEvent(new Event('change', {bubbles:true}));
        });
      });
      // The exact existing Shopify variant, including Canvas as option 1, is the submitted ID.
      master.value = String(selected.id);
      master.dispatchEvent(new Event('change', {bubbles:true}));
      syncing = false;
    }
    function choiceButton(label, active, disabled, click) {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'uk-portrait__choice';
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', String(active)); button.disabled = disabled;
      const title = document.createElement('strong'); title.textContent = label; button.appendChild(title);
      button.addEventListener('click', click);
      return button;
    }
    function render() {
      const finishMount = $('[data-uk-finishes]'); finishMount.replaceChildren();
      [{key:'none',label:'Print'},{key:'canvas',label:'Canvas'},{key:'framed',label:'Framed'}].forEach(({key,label}) => {
        const matching = variants.filter(v => familyOf(finishOf(v)) === key);
        if (!matching.length) return;
        const button = choiceButton(label, key === familyOf(finish), !matching.some(v => v.available), () => {
          selected = chooseVariant(key === 'framed' ? preferredFrame : key, size);
          finish = finishOf(selected); size = sizeOf(selected); syncNative(); render();
        });
        const available = matching.filter(v => v.available);
        const cheapest = (available.length ? available : matching).reduce((a,b) => a.price < b.price ? a : b);
        const from = document.createElement('span'); from.className = 'uk-portrait__finish-price'; from.textContent = `From ${money(cheapest)}`;
        button.appendChild(from); finishMount.appendChild(button);
      });
      const frameMount = $('[data-uk-frames]'); frameMount.replaceChildren();
      $('[data-uk-frame-options]').hidden = familyOf(finish) !== 'framed';
      frameKeys.forEach(key => {
        const matching = variants.filter(v => finishOf(v) === key);
        if (!matching.length) return;
        const button = choiceButton(names[key], key === finish, !matching.some(v => v.available), () => {
          preferredFrame = key; selected = chooseVariant(key, size);
          finish = finishOf(selected); size = sizeOf(selected); syncNative(); render();
        });
        const swatch = document.createElement('span'); swatch.className = 'uk-portrait__swatch'; swatch.dataset.swatch = key; swatch.setAttribute('aria-hidden','true');
        button.prepend(swatch); frameMount.appendChild(button);
      });
      const sizeMount = $('[data-uk-sizes]'); sizeMount.replaceChildren();
      const possible = [...new Set(variants.filter(v => finishOf(v) === finish).map(sizeOf))];
      possible.forEach(key => {
        const matching = variants.filter(v => finishOf(v) === finish && sizeOf(v) === key);
        const variant = matching.find(v => v.available) || matching[0];
        const displayName = sizeNames[key] || key;
        const button = choiceButton(displayName, key === size, !variant?.available, () => { selected = variant; size = key; syncNative(); render(); });
        button.dataset.size = key;
        const dimensionsLabel = document.createElement('span'); dimensionsLabel.className = 'uk-portrait__size-dimensions'; dimensionsLabel.textContent = key === '30X40' ? dimensions[key] : dimensions[key] ? `${key} · ${dimensions[key]}` : variant.options[0]; button.appendChild(dimensionsLabel);
        const price = document.createElement('span'); price.className = 'uk-portrait__size-price'; price.textContent = money(variant); button.appendChild(price);
        sizeMount.appendChild(button);
      });
      const inclusions = finish === 'canvas'
        ? ['Your portrait printed on canvas', 'Stretched over a 2 cm wooden frame', 'Hanging kit included']
        : finish === 'none'
          ? ['Your portrait as a premium art print', 'Premium 200 gsm matte paper']
          : ['Your portrait as a premium art print', `${finish === 'natural' ? 'Natural wood frame' : names[finish]} included`, 'Ready to hang'];
      $('[data-uk-inclusion]').replaceChildren(...inclusions.map(text => {
        const item = document.createElement('li'); item.textContent = text; return item;
      }));
      $('[data-uk-summary-finish]').textContent = finish === 'none' ? 'Print' : names[finish];
      $('[data-uk-summary-choice]').textContent = `${sizeNames[size] || size} · ${size === '30X40' ? dimensions[size] : size}`;
      $('[data-uk-total]').textContent = money(selected);
      root.querySelectorAll('[data-uk-art-stage]').forEach(stage => {
        stage.dataset.finish = finish;
        const ratio = size === '30X40' ? '3 / 4' : '21 / 29.7';
        stage.style.setProperty('--pop-canvas-ratio', ratio);
        stage.style.setProperty('--pop-portrait-ratio', ratio);
      });
      order.hidden = demo; $('[data-uk-demo-upload]').hidden = !demo; $('[data-uk-demo-note]').hidden = !demo;
      order.disabled = demo || !portrait || !selected.available;
      root.dataset.variantId = String(selected.id);
    }
    function showReady(isDemo = false) {
      const raw = urlInput()?.value || '';
      if (!isDemo && !/^https?:\/\//i.test(raw)) return;
      demo = isDemo; portrait = isDemo ? '' : raw;
      root.querySelectorAll('[data-uk-art]').forEach(img => { img.src = isDemo ? demoArtwork : raw; });
      root.dataset.view = 'ready'; $('.uk-portrait__upload').hidden = true; $('.uk-portrait__ready').hidden = false;
      syncNative(); render();
      requestAnimationFrame(() => { $('[data-uk-ready-title]').focus({preventScroll:true}); root.scrollIntoView({behavior:'smooth',block:'start'}); });
    }
    function restart() {
      demo = false; root.dataset.view = 'upload'; $('.uk-portrait__upload').hidden = false; $('.uk-portrait__ready').hidden = true;
      composer.classList.remove('gemini-transformer--hidden'); composer.removeAttribute('aria-hidden');
      $('[data-uk-order-status]').textContent = '';
      if (file) file.value = '';
      composer.querySelector('.gemini-transformer__actions')?.classList.remove('uk-show-retry');
      root.scrollIntoView({behavior:'smooth',block:'start'});
    }
    $('[data-uk-demo]')?.addEventListener('click', () => showReady(true));
    $('[data-uk-demo-upload]').addEventListener('click', () => { restart(); file?.click(); });
    file?.addEventListener('change', () => {
      if (!file.files?.length) return;
      demo = false; portrait = ''; order.disabled = true;
      composer.querySelector('.gemini-transformer__actions')?.classList.remove('uk-show-retry');
      // Existing engine's file-change handler runs first and owns validation and generation.
      if (generate && !generate.disabled) generate.click();
    });
    const status = composer.querySelector('.gemini-transformer__status');
    if (status) new MutationObserver(() => {
      composer.querySelector('.gemini-transformer__actions')?.classList.toggle('uk-show-retry', status.classList.contains('gemini-transformer__status--error'));
    }).observe(status, {attributes:true,childList:true,subtree:true});
    new MutationObserver(() => {
      if (composer.classList.contains('gemini-transformer--hidden')) showReady(false);
    }).observe(composer, {attributes:true,attributeFilter:['class']});
    document.addEventListener('change', event => {
      if (event.target === urlInput()) {
        setTimeout(() => { if (composer.classList.contains('gemini-transformer--hidden')) showReady(false); }, 0);
      } else if (event.target === master && !syncing) {
        const nativeVariant = variants.find(v => String(v.id) === master.value);
        if (nativeVariant) {
          selected = nativeVariant; finish = finishOf(selected); size = sizeOf(selected);
          if (frameKeys.includes(finish)) preferredFrame = finish;
          render();
        }
      }
    });
    order.addEventListener('click', () => {
      if (demo || !portrait || !selected.available || urlInput()?.value !== portrait) return;
      syncNative();
      if (nativeOrder.disabled) { $('[data-uk-order-status]').textContent = 'This option is unavailable. Please choose another size or finish.'; return; }
      nativeOrder.click();
    });
    // Keep any existing cart validation message visible beside the new order button.
    new MutationObserver(() => {
      const message = form.querySelector('.errors, .product-form__error-message, [role="alert"]');
      if (message?.textContent.trim()) $('[data-uk-order-status]').textContent = message.textContent.trim();
    }).observe(form, {childList:true,subtree:true,characterData:true});
    render();
    if (new URLSearchParams(location.search).get('portrait_ui_demo') === '1') showReady(true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
